<button type="button" class="debug-fab" (click)="toggle()">
  {{ isOpen ? '✕' : '🐞' }}
</button>

<div class="debug-panel" *ngIf="isOpen">
  <div class="debug-header">
    <span class="debug-title">Debugger</span>
    <div class="debug-header-actions">
      <button type="button" class="debug-btn" (click)="refreshSnapshot()">Обновить</button>
      <button type="button" class="debug-btn" (click)="copyAll(logsSnapshot)">Скопировать всё</button>
      <button type="button" class="debug-btn debug-btn-close" (click)="close()">✕</button>
    </div>
  </div>

  <div class="debug-tabs">
    <button type="button" class="debug-tab" [class.active]="activeTab === 'auth'" (click)="setTab('auth')">Auth / SSO</button>
    <button type="button" class="debug-tab" [class.active]="activeTab === 'storage'" (click)="setTab('storage')">Cookies / Storage</button>
    <button type="button" class="debug-tab" [class.active]="activeTab === 'requests'" (click)="setTab('requests')">
      Requests <span class="debug-count" *ngIf="(logs$ | async) as logs">{{ logs.length }}</span>
    </button>
  </div>

  <div class="debug-body">

    <ng-container *ngIf="activeTab === 'auth'">
      <div class="debug-section">
        <div class="debug-row"><span class="debug-label">URL</span><span class="debug-value">{{ currentUrl }}</span></div>
        <div class="debug-row"><span class="debug-label">User-Agent</span><span class="debug-value">{{ userAgent }}</span></div>
        <div class="debug-row"><span class="debug-label">isLoggedIn</span><span class="debug-value">{{ isLoggedIn }}</span></div>
        <div class="debug-row"><span class="debug-label">isDeviceMobile</span><span class="debug-value">{{ isDeviceMobile }}</span></div>
        <div class="debug-row"><span class="debug-label">lang</span><span class="debug-value">{{ lang }}</span></div>
      </div>

      <div class="debug-section">
        <div class="debug-section-title">SSO cookie</div>
        <pre class="debug-pre" [class.debug-empty]="!ssoToken">{{ ssoToken || '(пусто / нет куки SSO)' }}</pre>
      </div>

      <div class="debug-section">
        <div class="debug-section-title">user_data cookie (raw)</div>
        <pre class="debug-pre" [class.debug-empty]="!rawUserDataCookie">{{ rawUserDataCookie || '(пусто / нет куки user_data)' }}</pre>
      </div>

      <div class="debug-section">
        <div class="debug-section-title">localStorage['user'] (raw)</div>
        <pre class="debug-pre" [class.debug-empty]="!rawUserLocalStorage">{{ rawUserLocalStorage || '(пусто)' }}</pre>
      </div>

      <div class="debug-section">
        <div class="debug-section-title">authService.user (итоговый распарсенный объект)</div>
        <pre class="debug-pre" [class.debug-empty]="!parsedUser">{{ pretty(parsedUser) }}</pre>
      </div>
    </ng-container>

    <ng-container *ngIf="activeTab === 'storage'">
      <div class="debug-section">
        <div class="debug-section-title">Все cookies ({{ allCookies.length }})</div>
        <table class="debug-table" *ngIf="allCookies.length; else emptyCookies">
          <tr *ngFor="let c of allCookies">
            <td class="debug-table-key">{{ c.key }}</td>
            <td class="debug-table-value">{{ c.value }}</td>
          </tr>
        </table>
        <ng-template #emptyCookies><div class="debug-empty-block">Куки отсутствуют</div></ng-template>
      </div>

      <div class="debug-section">
        <div class="debug-section-title">localStorage ({{ allLocalStorage.length }})</div>
        <table class="debug-table" *ngIf="allLocalStorage.length; else emptyLs">
          <tr *ngFor="let c of allLocalStorage">
            <td class="debug-table-key">{{ c.key }}</td>
            <td class="debug-table-value">{{ c.value }}</td>
          </tr>
        </table>
        <ng-template #emptyLs><div class="debug-empty-block">localStorage пуст</div></ng-template>
      </div>
    </ng-container>

    <ng-container *ngIf="activeTab === 'requests'">
      <div class="debug-section-title debug-requests-title">
        <span>HTTP-запросы (сверху новые)</span>
        <button type="button" class="debug-btn" (click)="clearLogs()">Очистить</button>
      </div>
      <ng-container *ngIf="logs$ | async as logs">
        <div class="debug-empty-block" *ngIf="!logs.length">Запросов пока не было</div>
        <div class="debug-request" *ngFor="let log of logs">
          <div class="debug-request-summary" [class.expanded]="isExpanded(log.id)" (click)="toggleRequest(log.id)">
            <span class="debug-request-method">{{ log.method }}</span>
            <span class="debug-request-status" [ngClass]="statusClass(log)">
              {{ log.pending ? '…' : (log.status || 'ERR') }}
            </span>
            <span class="debug-request-url" [title]="log.url">{{ shortUrl(log.url) }}</span>
            <span class="debug-request-duration" *ngIf="log.durationMs != null">{{ log.durationMs }}ms</span>
          </div>
          <div class="debug-request-details" *ngIf="isExpanded(log.id)">
            <div class="debug-section-title">Request headers</div>
            <pre class="debug-pre">{{ pretty(log.requestHeaders) }}</pre>
            <div class="debug-section-title" *ngIf="log.requestBody != null">Request body</div>
            <pre class="debug-pre" *ngIf="log.requestBody != null">{{ pretty(log.requestBody) }}</pre>
            <div class="debug-section-title" *ngIf="log.responseBody != null">Response body</div>
            <pre class="debug-pre" *ngIf="log.responseBody != null">{{ pretty(log.responseBody) }}</pre>
            <div class="debug-section-title" *ngIf="log.error">Error</div>
            <pre class="debug-pre debug-pre-error" *ngIf="log.error">{{ pretty(log.error) }}</pre>
          </div>
        </div>
      </ng-container>
    </ng-container>

  </div>
</div>
